import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


// Get All Tariff Heads
export const getTariffHeadsReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_TARIFF_HEADS_API, { params })
}

// Get Tariff Heads With Details (rates, meterSlabs, taxRule)
export const getTariffHeadsWithDetailsReq = (action) => {
    const params = action?.data || {};
    return axiosInstance.get(apiEndpoints.GET_TARIFF_HEADS_WITH_DETAILS_API, { params })
}

// Get Tariff Head Details by ID
export const getTariffHeadDetailsReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.GET_TARIFF_HEAD_DETAILS_API.replace(':id', id);
    return axiosInstance.get(url)
}

// Create Tariff Head
export const createTariffHeadReq = (action) => {
    const payload = action?.data || {};
    const body = { ...payload };
    delete body.onSuccess;

    return axiosInstance.post(apiEndpoints.CREATE_TARIFF_HEAD_API, body)
}

// Update Tariff Head
export const updateTariffHeadReq = (action) => {
    const payload = action?.data || {};
    const { id } = payload;
    const url = apiEndpoints.UPDATE_TARIFF_HEAD_API.replace(':id', id);

    const body = { ...payload };
    delete body.id;
    delete body.onSuccess;

    return axiosInstance.put(url, body)
}

// Update Tariff Head Status (Activate/Deactivate)
export const updateTariffHeadStatusReq = (action) => {
    const payload = action?.data || {};
    const { id, status } = payload;
    const url = apiEndpoints.UPDATE_TARIFF_HEAD_STATUS_API.replace(':id', id);

    return axiosInstance.patch(url, { status })
}

// Delete Tariff Head (Soft Delete)
export const deleteTariffHeadReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.DELETE_TARIFF_HEAD_API.replace(':id', id);

    return axiosInstance.delete(url)
}
